declare namespace $ {

	export class $mol_icon_equalizer extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=equalizer.view.tree.d.ts.map